import { RunnerModularWorkflowStep } from 'features/modular-workflow/runner/types-runner';

export const hasStepEditableFields = (step?: RunnerModularWorkflowStep) =>
  step?.inputs.some(input => input.is_editable) ?? false;
